module.exports = __webpack_public_path__ + "static/media/bark_square.32461f7e.svg";